var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "box view-nav-bar" }, [
      _c("div", { staticClass: "d-flex align-items-center w-100" }, [
        _c("span", { staticClass: "text-muted mr-auto" }, [
          _vm._v("\n                FTP server "),
          _c("code", [
            _vm._v(
              _vm._s(_vm.bucket.host || "?") +
                "/" +
                _vm._s(_vm.bucket.root || "")
            ),
          ]),
          _vm._v("\n                → "),
          _c("code", [_vm._v(_vm._s(_vm.bucket.folder))]),
          _vm._v(" "),
          _vm.bucket.busy
            ? _c(
                "span",
                {
                  staticClass: "badge badge-warning ml-2",
                  attrs: { title: "An import or a sync holds the lock" },
                },
                [_vm._v("import running")]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("label", { staticClass: "mb-0 mr-2 text-muted" }, [_vm._v("Last")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.days,
                expression: "days",
              },
            ],
            staticClass: "form-control form-control-sm mr-2",
            staticStyle: { width: "6rem" },
            attrs: { disabled: _vm.running },
            on: {
              change: [
                function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.days = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                function ($event) {
                  return _vm.loadFiles(false)
                },
              ],
            },
          },
          _vm._l([7, 30, 90], function (n) {
            return _c("option", { key: n, domProps: { value: n } }, [
              _vm._v(_vm._s(n) + " days"),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-outline-secondary mr-2",
            attrs: {
              disabled: _vm.running || _vm.loadingFiles,
              title:
                "List the FTP server again (the listing is cached for 5 minutes)",
            },
            on: {
              click: function ($event) {
                return _vm.loadFiles(true)
              },
            },
          },
          [_vm._v("\n                Refresh listing\n            ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-primary",
            attrs: {
              disabled: _vm.running || _vm.bucket.busy,
              title:
                "Download the files of the last " +
                _vm.days +
                " days that are missing or changed on the server",
            },
            on: { click: _vm.syncDays },
          },
          [
            _vm.running === "days"
              ? _c("span", [_vm._v("Syncing…")])
              : _c("span", [_vm._v("Sync last " + _vm._s(_vm.days) + " days")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "box-content" },
        [
          _c("heading", {
            attrs: { upper: "Recent FTP syncs", border: "" },
            scopedSlots: _vm._u([
              {
                key: "lower",
                fn: function () {
                  return [
                    _vm._v(
                      "\n                    The last " +
                        _vm._s(_vm.runsBucket.limit || 20) +
                        " sync runs (scheduled hourly, from the command line, or from this page).\n                    Filtering and importing the downloaded files is done by the next scheduled import, or from\n                    "
                    ),
                    _c("router-link", { attrs: { to: "/settings" } }, [
                      _vm._v("Settings"),
                    ]),
                    _vm._v(".\n                "),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _vm.loadingRuns
            ? _c("div", { staticClass: "text-center text-muted py-3" }, [
                _vm._v("Loading…"),
              ])
            : !_vm.runs.length
            ? _c("div", { staticClass: "text-center text-muted py-3" }, [
                _vm._v("No sync runs recorded yet."),
              ])
            : _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.runs, function (run) {
                      return [
                        _c(
                          "tr",
                          {
                            key: run.id,
                            class: run.body ? "cursor-pointer" : "",
                            on: {
                              click: function ($event) {
                                return _vm.toggle(run.id)
                              },
                            },
                          },
                          [
                            _c("td", [
                              _vm._v(_vm._s(_vm.formatDate(run.created_at))),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(run.subject.replace(/^FTP sync: /, ""))
                              ),
                              run.user_id
                                ? _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(" · user " + _vm._s(run.user_id)),
                                  ])
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _c(
                                "span",
                                {
                                  staticClass: "badge",
                                  class: _vm.levelClass(run.level),
                                },
                                [_vm._v(_vm._s(run.level))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.formatInt(run.gauges["files listed"])
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(
                                _vm._s(_vm.formatInt(run.gauges.downloaded))
                              ),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(_vm.formatInt(run.gauges.skipped))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticClass: "text-right",
                                class: run.gauges.failed ? "text-danger" : "",
                              },
                              [_vm._v(_vm._s(_vm.formatInt(run.gauges.failed)))]
                            ),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right" }, [
                              _vm._v(_vm._s(run.gauges.seconds)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        run.body && _vm.expanded === run.id
                          ? _c("tr", { key: run.id + "-body" }, [
                              _c("td", { attrs: { colspan: "8" } }, [
                                _c("pre", { staticClass: "small mb-0" }, [
                                  _vm._v(_vm._s(run.body)),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "box" }, [
      _c(
        "div",
        { staticClass: "box-content" },
        [
          _c("heading", {
            attrs: {
              upper: "Raw folder vs FTP server, last " + _vm.days + " days",
              border: "",
            },
            scopedSlots: _vm._u([
              {
                key: "lower",
                fn: function () {
                  return [
                    _vm._v(
                      "\n                    One row per day file on the server or in "
                    ),
                    _c("code", [_vm._v(_vm._s(_vm.bucket.folder))]),
                    _vm._v(".\n                    "),
                    _c("strong", [_vm._v("same")]),
                    _vm._v(
                      ": identical size and not newer on the server ·\n                    "
                    ),
                    _c("strong", [_vm._v("remote newer")]),
                    _vm._v(" / "),
                    _c("strong", [_vm._v("size differs")]),
                    _vm._v(
                      ": the next sync downloads it ·\n                    "
                    ),
                    _c("strong", [_vm._v("missing local")]),
                    _vm._v(": never downloaded ·\n                    "),
                    _c("strong", [_vm._v("local only")]),
                    _vm._v(": no longer on the server.\n                    "),
                    _c("em", [_vm._v("Resync")]),
                    _vm._v(
                      " downloads that one file again, changed or not.\n                "
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _vm._v(" "),
          _vm.loadingFiles
            ? _c("div", { staticClass: "text-center text-muted py-3" }, [
                _vm._v("Listing the FTP server…"),
              ])
            : !_vm.files.length
            ? _c("div", { staticClass: "text-center text-muted py-3" }, [
                _vm._v(
                  "No day files in the last " + _vm._s(_vm.days) + " days."
                ),
              ])
            : _c("table", { staticClass: "shx-table w-100 mt-2" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.files, function (row) {
                    return _c("tr", { key: row.file }, [
                      _c(
                        "td",
                        [
                          row.local_size !== null
                            ? _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: "/admissions/sources/" + row.file,
                                  },
                                },
                                [_c("code", [_vm._v(_vm._s(row.file))])]
                              )
                            : _c("code", [_vm._v(_vm._s(row.file))]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to:
                                  "/admissions/day?from=" +
                                  row.day +
                                  "&to=" +
                                  row.day,
                              },
                            },
                            [_vm._v(_vm._s(row.day))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "span",
                          {
                            staticClass: "badge",
                            class: _vm.statusClass(row.status),
                          },
                          [_vm._v(_vm._s(row.status.replace("_", " ")))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            row.remote_size !== null
                              ? _vm.formatSize(row.remote_size)
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(row.remote_modified))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(
                          _vm._s(
                            row.local_size !== null
                              ? _vm.formatSize(row.local_size)
                              : "—"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(row.local_modified))),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "text-right" }, [
                        row.remote_size !== null
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-sm btn-outline-primary",
                                attrs: {
                                  disabled: _vm.running || _vm.bucket.busy,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.syncFile(row)
                                  },
                                },
                              },
                              [
                                _vm.running === row.file
                                  ? _c("span", [_vm._v("…")])
                                  : _c("span", [_vm._v("Resync")]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("When")]),
        _vm._v(" "),
        _c("th", [_vm._v("Run")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }, [_vm._v("Outcome")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Listed")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-100" }, [
          _vm._v("Downloaded"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Skipped")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Failed")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Seconds")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("File")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Play date")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-100" }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Remote")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("Remote modified")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right shx-th-80" }, [_vm._v("Local")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-140" }, [_vm._v("Local modified")]),
        _vm._v(" "),
        _c("th", { staticClass: "shx-th-80" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }